module.exports = "pegasus/assets/themelp1/large/53.png";